import React, { useEffect, useState, useMemo } from "react";
import SelectInput from "./../../components/common/ui/Inputs/SelectInput";
import { TextInput } from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import Table from "../../components/common/table/Table";
import { useDispatch, useSelector } from "react-redux";
import { PODAction } from "../../_store/pod.slice";
import { masterActions } from "../../_store";
import { history } from "../../_helpers";
import generateXlsx from "../../components/common/export/generateXlsx";
import activeIcon from "../../assets/svg/approved.svg";
import inactiveIcon from "../../assets/svg/inactive-user.svg";
import downloadIcon from "../../assets/svg/logs.svg";
import CustomLoader from "../../components/common/ui/Loader";
import Swal from "sweetalert2";
import AddIcon from "../../assets/svg/btn_icons/create-btn-icon.svg";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";

// Constants for default values
const DEFAULT_SHARED_POD = 2;
const DEFAULT_ACTIVE_STATUS = 2;
const DEFAULT_PAGE_NO = 1;
const DEFAULT_ROW_COUNT_PER_PAGE = 10;

function PODList() {
  const dispatch = useDispatch();
  const { commonFacilityCode } = useSelector((state) => state.auth);
  const { podStatusOptions, sharedPodOptions } = useSelector(
    (state) => state.dropdownOptions
  );
  const podListData = useSelector((state) => state.pod?.getPODList || {});

  const loading = useSelector((state) => state.pod?.loading);
  const [isloading, setisloading] = useState(false);

  const PODSearchData = useSelector((state) => state?.pod?.PODData);

  const isPageReloading = useSelector((state) => state.master?.isPageReload);

  const shouldShowExcelExport = podListData?.DataList?.length > 0;
  const [podListInput, setPodListInput] = useState(PODSearchData);
  const [showSearchFields, setShowSearchFields] = useState(false);
  // Dispatch the action when FacilityID changes in loadManagementUser
  let sorting = false;
  let updatedSearch = { ...PODSearchData };
  useEffect(() => {
    setPodListInput(PODSearchData);
  }, [PODSearchData]);

  useEffect(() => {
    if (commonFacilityCode) {
      setisloading(true);
      dispatch(
        PODAction.LoadPODList({
          ...PODSearchData,
          FacilityID: commonFacilityCode,
        })
      )
        .then((result) => {
          setisloading(false);
          // if (result?.payload?.DataList?.length === 0) {
          //   const searchParams = { ...PODSearchData };
          //   searchParams.FacilityID = commonFacilityCode;
          //   searchParams.PageNo = 1;
          //   searchParams.RowCountPerPage = 10;
          //   dispatch(PODAction.searchPOD(searchParams));
          //   PODAction.LoadPODList(searchParams);
          // }
        })
        .catch((err) => {
          showToastNotification("Failed to load POD list", "error");
        });
    }
  }, [
    commonFacilityCode,
    dispatch,
    isPageReloading,
  ]);

  // Update PODListData when commonFacilityCode changes
  useEffect(() => {
    if (commonFacilityCode !== 0) {
      setPodListInput((prev) => ({
        ...prev,
        FacilityID: commonFacilityCode,
      }));
    } else {
      // Handle case when commonFacilityCode is 0, if necessary
      setPodListInput((prev) => ({
        ...prev,
        FacilityID: 0,
      }));
    }
  }, [commonFacilityCode]);

  // // Dispatch the action when FacilityID changes in loadManagementUser
  // useEffect(() => {
  //   if (podListInput?.FacilityID !== 0) {
  //     const loadPODList = async () => {
  //       try {
  //         await dispatch(
  //           PODAction.LoadPODList({
  //             ...podListInput,
  //             FacilityID: commonFacilityCode,
  //           })
  //         );
  //       } catch (error) {
  //         console.error("Error loading POD list:", error);
  //         // Optionally dispatch an error action or show a notification
  //       }
  //     };
  //     loadPODList();
  //   }
  // }, [podListInput?.FacilityID, podListInput?.RowCountPerPage, podListInput?.PageNo, dispatch]);

  // Load facility dropdown on component mount
  useEffect(() => {
    const loadFacilities = async () => {
      try {
        await dispatch(
          masterActions.LoadFacilityDropDown({
            FacilityID: 0,
            ActiveStatus: 1,
          })
        );
      } catch (error) {
        console.error("Error loading facilities:", error);
        // Optionally dispatch an error action or show a notification
      }
    };
    loadFacilities();
  }, [dispatch, commonFacilityCode]);

  // Column configuration for the table
  const columns = useMemo(
    () => [
      {
        key: "PodCode",
        name: "Code",
        selector: (row) => row.PodCode,
        sortable: true,

        cell: (row) => (
          <div
            onClick={() => navigateToEditPOD(row)}
            className="Common_Link_Style"
          // Styles for clickable link
          >
            {row.PodCode}
          </div>
        ),
      },
      {
        key: "PodName",
        name: "Name",
        selector: (row) => row.PodName,
        sortable: true,
      },
      {
        key: "Inmates",
        name: "Inmates",
        selector: (row) => row.Inmates,
        sortable: true,
      },
      {
        key: "Kiosks",
        name: "Kiosks",
        selector: (row) => row.Kiosks,
        sortable: true,
      },
      {
        key: "SharedPod",
        name: "Shared", // Displays "Yes" or "No" based on the value
        selector: (row) => (row.SharedPod ? "Yes" : "No"),
        sortable: true,
      },
      {
        key: "IsAllowedIndefiniteKioskAccess",
        name: "Indefinite Kiosk Access", // Displays "Yes" or "No" based on the value
        selector: (row) => (row.IsAllowedIndefiniteKioskAccess ? "Yes" : "No"),
        sortable: true,
      },
      {
        key: "ActiveStatus",
        width: "80px",
        name: "Status",
        selector: (row) => row.ActiveStatus,
        cell: (row) => (
          <div>
            <img
              className="in-icon-size"
              src={row.ActiveStatus === 1 ? activeIcon : inactiveIcon}
              alt={row.ActiveStatus === 1 ? "Active" : "Inactive"}
              title={row.ActiveStatus === 1 ? "Active" : "Inactive"}
            />
          </div>
        ),
        sortable: true,
      },
      {
        width: "80px",
        name: "Log",
        //selector: (row) => row.ActiveStatus, // For consistent return types
        cell: (row) => (
          <div>
            <img
              className="in-icon-size cursor-pointer"
              src={downloadIcon}
              alt="View Log"
              title="View Log"
              onClick={() => handleViewLog(row)} // Call function when clicked
            />
          </div>
        ),
        //sortable: true,
      },
    ],
    []
  );

  // Function to handle form submission
  const handlePODSearchSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    // Check if any relevant POD data is available to submit
    const { PodCode, PodName, SharedPod, ActiveStatus } = podListInput;
    if (PodCode || PodName || SharedPod || ActiveStatus) {
      const searchData = {
        ...PODSearchData,
        FacilityID: commonFacilityCode,
        PageNo: 1,
        RowCountPerPage: 10,
      };
      dispatch(PODAction.searchPOD(searchData));
      setPodListInput(searchData);
      dispatch(PODAction.LoadPODList(searchData));
    }
  };

  // const resetState = {
  //   PodCode: "",
  //   PodName: "",
  //   FacilityID: commonFacilityCode, // Using the commonFacilityCode from the current state
  //   SharedPod: DEFAULT_SHARED_POD,
  //   ActiveStatus: DEFAULT_ACTIVE_STATUS,
  //   PageNo: DEFAULT_PAGE_NO,
  //   RowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE,
  //   SortBy: "",
  // };

  // // Set the state with reset values
  // setPodListInput(resetState);

  const resetPODList = () => {
    if (commonFacilityCode) {
      // Reset form
      dispatch(PODAction.resetForm());
      dispatch(PODAction.resetSearchPOD());

      // Immediately update state with default values
      setPodListInput((prevState) => {
        const newState = {
          PodCode: "",
          PodName: "",
          FacilityID: commonFacilityCode,
          SharedPod: DEFAULT_SHARED_POD,
          ActiveStatus: DEFAULT_ACTIVE_STATUS,
          PageNo: DEFAULT_PAGE_NO,
          RowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE,
          SortBy: "",
        };

        // Dispatch LoadPODList with updated values
        dispatch(PODAction.LoadPODList(newState));
        return newState;
      });
    }
  };

  const handleViewLog = (row) => {
    if (!row?.PodID) return;

    history.navigate("PODList/InmateLoginLog", {
      state: { id: row.PodID }, // Pass PodID securely via state
    });

    dispatch(PODAction.resetForm()); // Reset the form state
  };

  const navigateToAddPOD = () => {
    Swal?.close();
    // Navigate to the "Add POD" page
    dispatch(PODAction.clearAddPODData());
    history.navigate("/Admin/PODList/Add", {
      state: {}, // Passing an empty state or just omitting the id completely
    }); // Use absolute path for clarity
  };

  //The function effectively updates the state based on input changes.
  const updateFormField = (e, isOnblur) => {
    // Ensure e.target is defined to prevent destructuring errors
    const { target } = e || {};

    if (!target) return; // Exit if target is not available

    const { name, value } = target;
    const searchData = { ...PODSearchData };
    searchData[name] = isOnblur ? value.trim() : value;

    // Update state using setPodListInput with previous state
    // setPodListInput((prev) => ({
    //   ...prev,
    //   [name]: value, // Set the value dynamically based on input name
    // }));

    dispatch(PODAction?.searchPOD(searchData));
  };

  // const updateSelectedOption = (selectedOption, name) => {
  //   if (!selectedOption) return;

  //   const valueToSet =
  //     selectedOption?.value != null
  //       ? parseInt(selectedOption.value, 10)
  //       : DEFAULT_SHARED_POD;
  //   setPodListInput((prev) => {
  //     const updatedParams = {
  //       ...prev,
  //       [name]: valueToSet,
  //       PageNo: 1,
  //       RowCountPerPage: 10,
  //     };

  //     if (
  //       typeof selectedOption === "object" &&
  //       selectedOption.value !== prev[name]
  //     ) {
  //       dispatch(
  //         PODAction.searchPOD({
  //           ...PODSearchData,
  //           [name]: valueToSet,
  //           PageNo: 1,
  //           RowCountPerPage: 10,
  //         })
  //       );
  //     }

  //     return updatedParams;
  //   });

  //   let data = {
  //     ...PODSearchData,
  //     FacilityID: commonFacilityCode,
  //     [name]: valueToSet,
  //   };

  //   if (commonFacilityCode) {
  //     dispatch(PODAction.LoadPODList(data));
  //   }
  // };

  const updateSelectedOption = (selectedOption, name) => {
    updatedSearch[name] = selectedOption?.value ?? DEFAULT_SHARED_POD;
    updatedSearch.RowCountPerPage = 10;
    updatedSearch.PageNo = 1;
    setPodListInput(updatedSearch);
    dispatch(PODAction.searchPOD(updatedSearch));
    dispatch(
      PODAction.LoadPODList({
        ...updatedSearch,
        FacilityID: commonFacilityCode,
      })
    );
  };

  // Function to handle the selection of a POD code and navigate to the Edit page
  const navigateToEditPOD = (row) => {
    Swal.close();
    const podID = row?.PodID;

    if (!podID) return; // Early return to exit if PodID is invalid

    history.navigate("/Admin/PODList/Add", {
      state: { id: podID, ActiveStatus: row.ActiveStatus }, // Pass the ID securely using state
    });
  };

  // Function to export POD data into an Excel file with specified columns and formatting.
  const exportPODDataToExcel = () => {
    // Define the title of the Excel sheet
    const title = "Pod_List";

    // Define the column headers for Excel
    const generateExcelColumns = [
      "Code",
      "Name",
      "Inmates",
      "Kiosks",
      "Shared",
      "Indefinite Kiosk Access",
      "Status",
    ];

    const updateTotalRows = {
      ...podListInput,
      RowCountPerPage: podListData?.TotalRecordCount,
      exportExcel: true,
      PageNo: 1,
    };

    // Dispatch and process the response
    dispatch(PODAction?.LoadPODList(updateTotalRows))
      .then((response) => {
        // Ensure fullPODData and DataList are valid
        const { DataList = [] } = response.payload || {}; // Assuming response contains DataList directly

        // Map the data for Excel
        const docList = DataList.map((obj) => ({
          Code: obj.PodCode,
          Name: obj.PodName,
          Inmates: obj.Inmates,
          Kiosks: obj.Kiosks,
          Shared: obj.SharedPod ? "Yes" : "No",
          IndefiniteKioskAccess: obj.IsAllowedIndefiniteKioskAccess
            ? "Yes"
            : "No",
          Status: obj.ActiveStatus === 1 ? "Active" : "Inactive",
        }));

        // Check if there is data before generating the Excel
        //if (docList.length === 0) return; // Early return if no data exists
        generateXlsx(docList, generateExcelColumns, title);
      })
      .catch((error) => {
        // Handle errors gracefully
        console.error("Error loading POD list:", error);
      });
  };

  // Updates the number of rows per page in the POD list data
  const handleRowCountChange = (newRowCount) => {
    setPodListInput((prevState) => ({
      ...prevState,
      PageNo: 1,
      RowCountPerPage: newRowCount, // Update row count per page
    }));
    dispatch(
      PODAction.searchPOD({
        ...PODSearchData,
        PageNo: 1,
        RowCountPerPage: newRowCount,
      })
    );

    dispatch(PODAction.LoadPODList({ ...PODSearchData, FacilityID: commonFacilityCode, PageNo: 1, RowCountPerPage: newRowCount, }))

  };

  // Handles page change for the POD list
  const handlePageChange = (newPage) => {
    if (sorting) {
      sorting = false;
      return;
    }
    setPodListInput((prevState) => ({
      ...prevState,
      PageNo: newPage, // Update page number to the new page
    }));
    dispatch(PODAction.searchPOD({ ...PODSearchData, PageNo: newPage }));
    dispatch(PODAction.LoadPODList({ ...PODSearchData, FacilityID: commonFacilityCode, PageNo: newPage, }))
  };

  if (loading || isloading) {
    return <CustomLoader />;
  }

  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...podListInput, FacilityID: commonFacilityCode };
    const newSortOrder = search.SortBy?.includes(column.key)
      ? search.SortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.SortBy = `${column.key} ${newSortOrder}`;
    setPodListInput(search);
    dispatch(
      PODAction.LoadPODList({
        ...podListInput,
        FacilityID: commonFacilityCode,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form onSubmit={handlePODSearchSubmit}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-floating mb-3">
              <TextInput
                name="PodCode"
                id="PodCode"
                label="Code"
                value={PODSearchData.PodCode}
                handleChange={updateFormField}
                placeholder="Code"
                maxLength={20}
                handleBlur={(e) => updateFormField(e, true)}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-floating mb-3">
              <SelectInput
                options={podStatusOptions}
                value={PODSearchData.ActiveStatus ?? 2} // Default to 2 if undefined
                handleChange={(selectedOption) =>
                  updateSelectedOption(selectedOption, "ActiveStatus")
                }
                isMulti={false}
                closeMenuOnSelect
                placeholder="--ALL--"
                label="Status"
                isClearable={PODSearchData.ActiveStatus !== 2} // Allow clearing if not default
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-floating mb-3">
              <TextInput
                name="PodName"
                id="PodName"
                label="Name"
                value={PODSearchData.PodName}
                handleChange={updateFormField}
                placeholder="Name"
                maxLength={30}
                handleBlur={(e) => updateFormField(e, true)}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-floating mb-3">
              <SelectInput
                options={sharedPodOptions}
                value={PODSearchData.SharedPod ?? 2} // Default to 2 if undefined
                handleChange={(selectedOption) =>
                  updateSelectedOption(selectedOption, "SharedPod")
                }
                isMulti={false}
                closeMenuOnSelect
                placeholder="--ALL--"
                label="Shared"
                isClearable={PODSearchData.SharedPod !== 2} // Allow clearing if not default
              />
            </div>
          </div>
        </div>

        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            variant="primary"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          ></Button>
          <Button
            variant="secondary"
            onClick={resetPODList}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      {commonFacilityCode ? (
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
            <div className=" d-block d-md-none">
              <div
                className=" d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h2 className="form_title_uppercase text-color">POD search</h2>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {/* Mobile only (Below md breakpoint) */}
            <div className="d-block d-md-none mt-2">
              {showSearchFields && renderSearch()}
            </div>
            {/* Web only (Desktop and above) */}
            <div className="mb-3 d-none d-md-block">
              <h2 className="form_title_uppercase text-color">POD search</h2>
            </div>
            {/* Web only (Desktop and above) */}
            <div className="d-none d-md-block">{renderSearch()}</div>
            {/* </div> */}
          </div>
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-2 resp-space">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <h2 className="form_title_uppercase mb-4 text-color">
                Pods List
              </h2>
              <div className="d-flex flex-wrap gap-3 align-items-center">
                <Button
                  variant="success"
                  className="me-2"
                  onClick={navigateToAddPOD}
                  label="Add Pod"
                  type="button"
                  status="btn-label"
                  //icon="circle-plus"
                  imgsrc={AddIcon}
                />
                {shouldShowExcelExport && (
                  <ExcelExport
                    variant="soft-gray"
                    handleExcelExport={exportPODDataToExcel}
                  />
                )}
              </div>
            </div>

            <Table
              columns={columns}
              data={podListData?.DataList}
              pagination
              onChangeRowsPerPage={handleRowCountChange}
              onChangePage={handlePageChange}
              totalRowCount={podListData?.TotalRecordCount}
              currentPage={podListInput?.PageNo}
              paginationPerPage={podListInput.RowCountPerPage}
              onSort={handleSort}
              serverSideSort
              sortColumn={podListInput?.SortBy?.split(" ")[0]}
              sortDirection={podListInput?.SortBy?.split(" ")[1]}
            />
          </div>
        </div>
      ) : (
        <h4 className="facility-card"> Select a Facility Code from the list</h4>
      )}
    </div>
  );
}

export default React.memo(PODList);
